import {SearchObjectType} from '../campaigns/copilot/agents/campaignSetupAgent/tools/general/searchObjectsTool/searchObjectsTool.enums';
import apiV2Service from '../api/api-v2.service';
import {AskAboutObjectsContext, AskAboutObjectsResponse} from './askAboutObjects.types';

const basePath = 'AskAboutObjects';

async function askAboutObjects({
  objectType,
  question,
  context,
}: {
  objectType: SearchObjectType;
  question: string;
  context: AskAboutObjectsContext;
}): Promise<AskAboutObjectsResponse> {
  const {data} = await apiV2Service.executePostRequest<AskAboutObjectsResponse>(
    `${basePath}/AskAboutObjects`,
    {objectType, question},
    {context},
  );

  return data;
}

export default {
  askAboutObjects,
};
